import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom"; // Added useNavigate
import { Helmet } from "react-helmet";
import { useStreamContext } from "../../contexts/StreamContext";
import { Container, Table } from "react-bootstrap";
import PublicNotificationSystem from "../../components/organisms/PublicNotificationSystem/PublicNotificationSystem";
import GoogleMapsEmbed from "../../components/organisms/GoogleMapsEmbed/GoogleMapsEmbed";
import LiveStreamEmbed from "../../components/organisms/LiveStreamEmbed/LiveStreamEmbed";
import { FaArrowCircleRight } from "react-icons/fa";
import "./SingleStream.css";

const SingleStream = () => {
    const { streamSlug } = useParams();
    const { stream, getStreamBySlug } = useStreamContext();
    const [localStream, setLocalStream] = useState(null);

    useEffect(() => {
        const fetchStream = async () => {
            const fetchedStream = await getStreamBySlug(streamSlug);
            if (!fetchedStream) {

            } else {
                setLocalStream(fetchedStream);
            }
        };
        fetchStream();
    }, [streamSlug, getStreamBySlug]); // Added navigate to dependencies

    useEffect(() => {
        const donationButtonContainer = document.getElementById(
            "churchcamlive-donation-btn-1"
        );

        if (donationButtonContainer) {
            const script = document.createElement("script");
            script.src =
                "/apps/donations/build/scripts/churchcamlive-donation-btn.js";
            script.setAttribute("data-form-id", "1");
            script.async = true;

            document.body.appendChild(script);

            return () => {
                if (document.body.contains(script)) {
                    document.body.removeChild(script);
                }
            };
        }
    }, []);

    const streamMetadata = localStream?.metadata;

    const jsonLd = localStream
        ? {
              "@context": "https://schema.org",
              "@type": "BroadcastEvent",
              "name": streamMetadata?.stream_short_name,
              "description": streamMetadata?.stream_long_name,
              "url": `https://churchcamlive.ie/${streamSlug}`,
              "publisher": {
                  "@type": "Organization",
                  "name": "ChurchCamLive",
                  "url": "https://churchcamlive.ie"
              },
              "startDate": streamMetadata?.start_date || "2023-01-01T00:00:00Z",
              "endDate": streamMetadata?.end_date || "2023-12-31T23:59:59Z",
              "location": {
                  "@type": "Place",
                  "name": streamMetadata?.stream_long_name,
              },
              "isLiveBroadcast": true
          }
        : null;

    return (
        <>
            <Helmet>
                <title>
                    {streamMetadata
                        ? `${streamMetadata.stream_short_name} Live Stream Page`
                        : "Loading..."}
                </title>
                <meta
                    name="description"
                    content={
                        streamMetadata
                            ? `${streamMetadata.stream_long_name} Live Stream`
                            : "Loading..."
                    }
                />
                {jsonLd && (
                    <script type="application/ld+json">
                        {JSON.stringify(jsonLd)}
                    </script>
                )}
            </Helmet>
            {!localStream ? (
                <div
                    style={{
                        position: "absolute",
                        top: "35%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        color: "#0f6fb5ff",
                        fontSize: "25px",
                    }}
                >
                    Loading...
                </div>
            ) : (
                <Container fluid className="py-5">
                    <h1 className="text-center fw-bold ccl-blue">
                        {streamMetadata?.stream_short_name}
                    </h1>
                    <p className="text-center my-0 mt-4">
                        Broadcasted live from:
                    </p>
                    <p className="text-center my-0 fw-bold ccl-blue">
                        {streamMetadata?.stream_long_name}
                    </p>

                    {/* Render the Timetables */}
                    {(streamMetadata?.daily_timetable?.length > 0 ||
                        streamMetadata?.weekend_timetable?.length > 0) && (
                        <div
                            className="col-xs-12 col-sm-8 col-md-6 offset-sm-2 offset-md-3 g-0 p-0 mt-5 mb-3"
                            style={{
                                borderRadius: "6px",
                                borderCollapse: "separate",
                                borderSpacing: "0",
                                border: "1px solid grey",
                                boxShadow:
                                    "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px",
                            }}
                        >
                            <Table
                                bordered
                                striped
                                className="schedule-timetable"
                            >
                                <tbody>
                                    {streamMetadata?.daily_timetable &&
                                        streamMetadata?.daily_timetable.map(
                                            (entry, index) => (
                                                <tr key={index}>
                                                    <td className="text-center">
                                                        {entry.service}
                                                    </td>
                                                    <td className="text-center">
                                                        {entry.days}
                                                    </td>
                                                    <td className="text-center fw-bold">
                                                        {entry.time}
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    {streamMetadata?.weekend_timetable &&
                                        streamMetadata?.weekend_timetable.map(
                                            (entry, index) => (
                                                <tr key={index}>
                                                    <td className="text-center">
                                                        {entry.service}
                                                    </td>
                                                    <td className="text-center">
                                                        {entry.days}
                                                    </td>
                                                    <td className="text-center fw-bold">
                                                        {entry.time}
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                </tbody>
                            </Table>
                        </div>
                    )}

                    {streamMetadata?.stream_website_url?.[0]?.length > 0 && (
                        <div className="text-center mt-5 mb-3">
                            <a
                                className="text-decoration-none ccl-blue fw-bold"
                                href={`${streamMetadata?.stream_website_url}`}
                                target="__blank"
                                rel="noopener"
                            >
                                Click here for more information on{" "}
                                {streamMetadata?.stream_short_name}
                            </a>
                        </div>
                    )}
                    {streamMetadata?.stream_donation_link?.[0]?.length > 0 && (
                        <div className="text-center mt-5 mb-3">
                            <a
                                className="text-decoration-none ccl-blue fw-bold"
                                href={`${streamMetadata?.stream_donation_link}`}
                                target="__blank"
                                rel="noopener"
                            >
                                Click here for donation details
                            </a>
                        </div>
                    )}

                    {streamMetadata?.newsletter_name && (
                        <div className="text-center mt-5 mb-3">
                            <a
                                className="text-decoration-none btn btn-primary shadow"
                                href={`https://assets.churchcamlive.ie/data/newsletters/${streamMetadata?.newsletter_name}`}
                                target="__blank"
                                rel="noopener"
                            >
                                Click here to view our newsletter{" "}
                                <FaArrowCircleRight className="fs-4" />
                            </a>
                        </div>
                    )}
                </Container>
            )}

            <div className="churchcamlive-donation-button" data-form-id="1" />
            <PublicNotificationSystem stream={localStream} />
            <LiveStreamEmbed stream={localStream && localStream} />
            <GoogleMapsEmbed stream={localStream} />
        </>
    );
};

export default React.memo(SingleStream);
